import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle, ChevronDown, ChevronUp, Calendar, Mail, Edit2, Send, User } from 'lucide-react';
export function DunderMifflinApplicationView() {
  const [expandedRef, setExpandedRef] = useState<string | null>(null);
  const [expandedGuarantor, setExpandedGuarantor] = useState<string | null>(null);
  const tradeReferences = [{
    id: 'paperplus',
    company: 'PaperPlus Wholesale',
    status: 'pending',
    statusText: 'Pending since March 28, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Todd Packer',
      phone: '(570) 555-0142',
      email: 't.packer@paperplus.com'
    },
    details: null
  }, {
    id: 'millerpaper',
    company: 'Miller Paper Supply',
    status: 'completed',
    statusText: 'Completed on March 27, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Tom Halpert',
      phone: '(215) 555-0188',
      email: 't.halpert@millerpaper.com'
    },
    details: {
      yearsAsCustomer: 12,
      creditLimit: '$75,000',
      currentBalance: '$8,200',
      paymentHabits: 'Prompt / Within Terms',
      recommended: 'Yes',
      responseDate: 'March 27, 2026'
    }
  }, {
    id: 'officemax',
    company: 'OfficeMax Distributors',
    status: 'not-sent',
    statusText: 'Not Sent',
    emailsSent: null,
    contact: {
      name: 'Gabe Lewis',
      phone: '(850) 555-0177',
      email: 'g.lewis@officemaxdist.com',
      address: '221 Commerce Way, Tallahassee FL 32301'
    },
    details: null
  }];
  return <div className="space-y-6" data-id="element-923" data-mp="lwbhbwmhchk8">
      {/* Application Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-924" data-mp="pv13adll37fh">
        <div className="flex items-center justify-between mb-4" data-id="element-925" data-mp="uvotix1znk8n">
          <div data-id="element-926" data-mp="ztgqw6lejyk8">
            <div className="flex items-center gap-3 mb-2" data-id="element-927" data-mp="zsxboxn4zo9w">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-928" data-mp="zrdrwx29uv3d">
                Credit Application
              </h2>
              <span className="px-3 py-1 bg-green-100 text-green-700 border border-green-300 rounded-full text-sm font-medium flex items-center gap-1" data-id="element-929" data-mp="2qy1xjp5nn93h">
                <span className="text-lg" data-id="element-930" data-mp="35o97thlidlt3">🔍</span>
                Ready for Review
              </span>
            </div>
            <div className="text-sm text-gray-600 space-y-1" data-id="element-931" data-mp="30u4wkm57mrm7">
              <p data-id="element-932" data-mp="3em1jmbs0ubbq">
                <span className="font-semibold" data-id="element-933" data-mp="3eljhiyioh2vw">Started On:</span> March 27,
                2026
              </p>
              <p data-id="element-934" data-mp="3anu7ju8i5y6v">
                <span className="font-semibold" data-id="element-935" data-mp="3olis10ynr3be">Submitted On:</span> March 27,
                2026
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-936" data-mp="3jnqvftn2it0v">
            <Download className="w-4 h-4" data-id="element-937" data-mp="1p8ockesiy96x" />
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Applicant Details */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-938" data-mp="4rovmhkttiu8">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-939" data-mp="9pqizepac4bi">
          Applicant Details
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-940" data-mp="3r4x8ym7qq4da">
          <div data-id="element-941" data-mp="3w51p2b4qkx2z">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-942" data-mp="3w4jkmr7x7cjz">
              Name
            </label>
            <p className="text-gray-900" data-id="element-943" data-mp="3i50mmr8tphle">Pam Beesly</p>
          </div>
          <div data-id="element-944" data-mp="3n43k9qmh4ljc">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-945" data-mp="3n4wlkc2nyiu3">
              Company
            </label>
            <p className="text-gray-900" data-id="element-946" data-mp="3885pocs77p98">Dunder Mifflin Paper Company Inc</p>
          </div>
          <div data-id="element-947" data-mp="3d78mj9y0yp64">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-948" data-mp="3d6yyvt0gcu3l">
              Role
            </label>
            <p className="text-gray-900" data-id="element-949" data-mp="16givk2d0fe8j">Office Administrator</p>
          </div>
          <div data-id="element-950" data-mp="1bdj72ssmp971">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-951" data-mp="1be18e3u5edlt">
              Department
            </label>
            <p className="text-gray-900" data-id="element-952" data-mp="37fmfnhshdyos">Administration</p>
          </div>
          <div data-id="element-953" data-mp="33h58wzcz2q7w">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-954" data-mp="33ej2x45qcirs">
              Email
            </label>
            <div className="flex items-center gap-2" data-id="element-955" data-mp="2ti68g42d20vz">
              <p className="text-gray-900" data-id="element-956" data-mp="2tho4smddcke1">pam.beesly@dundermifflin.com</p>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-957" data-mp="2ok4shs08ehoq" />
            </div>
          </div>
          <div data-id="element-958" data-mp="2js4pfqov78nx">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-959" data-mp="2jrl5k4fnma79">
              Phone Number
            </label>
            <p className="text-gray-900" data-id="element-960" data-mp="2foor8px5d094">(570) 555-0126</p>
          </div>
        </div>

        {/* Email Verification */}
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-961" data-mp="25slp3k2ap1m6">
          <div className="flex items-start gap-3" data-id="element-962" data-mp="25upvc8no2cpm">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-963" data-mp="20ujvi578tjwg" />
            <div data-id="element-964" data-mp="1qpu1qmlztm3b">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-965" data-mp="1qqd9xblucw45">
                Email Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-966" data-mp="1vndf7kav9uu7">
                Email verified and matches company domain.
              </p>
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="mt-4" data-id="element-967" data-mp="25ljio6cbn916">
          <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-968" data-mp="25krsjb1hu3ia">
            Location (IP Address)
          </label>
          <div className="flex items-center gap-2" data-id="element-969" data-mp="1cxxbyp7sroa3">
            <p className="text-gray-900" data-id="element-970" data-mp="1cygkxgfgz2bz">Scranton, PA (136.61.36.131)</p>
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-971" data-mp="1hw8ml25x22td" />
          </div>
        </div>

        {/* IP Verification */}
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-972" data-mp="1mpjnynrylrdw">
          <div className="flex items-start gap-3" data-id="element-973" data-mp="p7t9il6chuko">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-974" data-mp="u7peonqs3s1t" />
            <div data-id="element-975" data-mp="u5uvbdv5o7zu">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-976" data-mp="u5cojnavabdo">
                IP Address Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-977" data-mp="h8g8kdrv9odk">
                Applicant location matches company headquarters.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-978" data-mp="qyrgscil2jq9">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-979" data-mp="37c7fzse325i">
          Company Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-980" data-mp="3uf85ds76rxxv">
          <div data-id="element-981" data-mp="d6bi1nwpt7v5">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-982" data-mp="d61ndn0q6cj4">
              Legal Business Name
            </label>
            <p className="text-gray-900" data-id="element-983" data-mp="86fd9mg71cej">Dunder Mifflin Paper Company, Inc.</p>
          </div>
          <div data-id="element-984" data-mp="1okfbmsze4tzo">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-985" data-mp="1ojx4307a2tcg">
              DBA
            </label>
            <p className="text-gray-900" data-id="element-986" data-mp="1jm3x44y5hvb4">Dunder Mifflin</p>
          </div>
          <div data-id="element-987" data-mp="1r54yajlhbcvb">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-988" data-mp="1r4lcuswme6cj">
              Business Address
            </label>
            <p className="text-gray-900" data-id="element-989" data-mp="1i582ly0o9dqr">
              1725 Slough Avenue
              <br data-id="element-990" data-mp="1i71dxqm8cm53" />
              Scranton, PA 18505
            </p>
          </div>
          <div data-id="element-991" data-mp="1m7brboccqetz">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-992" data-mp="1m8wakht7ubcj">
              Years in Business
            </label>
            <p className="text-gray-900" data-id="element-993" data-mp="2ev7m2nid1wo4">77 years</p>
          </div>
          <div data-id="element-994" data-mp="2eupkdbcxiq8t">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-995" data-mp="2exbn8xovkhkp">
              Tax ID / EIN
            </label>
            <p className="text-gray-900" data-id="element-996" data-mp="2555wfrad0673">**-***1865</p>
          </div>
          <div data-id="element-997" data-mp="253bac9ncq81f">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-998" data-mp="2svidpsrhvfac">
              Industry
            </label>
            <p className="text-gray-900" data-id="element-999" data-mp="2xm8hx2o6pc3g">Paper & Office Supplies</p>
          </div>
        </div>
      </div>

      {/* Requested Credit Terms */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1000" data-mp="28wnhy27lv7ym">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1001" data-mp="2431catzv04cb">
          Requested Credit Terms
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1002" data-mp="1z5srsmr8no7w">
          <div data-id="element-1003" data-mp="1u77r6m82r2ix">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1004" data-mp="1u7r9i41mzsxh">
              Requested Credit Limit
            </label>
            <p className="text-gray-900 text-lg font-semibold" data-id="element-1005" data-mp="2rs41cmwtozgu">$50,000</p>
          </div>
          <div data-id="element-1006" data-mp="2mvvf6pk7k606">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1007" data-mp="2mt9aqysm66m6">
              Payment Terms
            </label>
            <p className="text-gray-900" data-id="element-1008" data-mp="2cx669maahvw2">Net 30</p>
          </div>
          <div data-id="element-1009" data-mp="2cz0j0dbeqhp2">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1010" data-mp="16gu9npn48m2l">
              Estimated Monthly Volume
            </label>
            <p className="text-gray-900" data-id="element-1011" data-mp="11gpq1qqwvb85">$15,000 - $20,000</p>
          </div>
          <div data-id="element-1012" data-mp="3d5dzqi6hb6t2">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1013" data-mp="3d5vxxkcpbv3m">
              Purpose
            </label>
            <p className="text-gray-900" data-id="element-1014" data-mp="3i4z3r70ia5cn">Office supplies and paper products</p>
          </div>
        </div>
      </div>

      {/* Trade References */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1015" data-mp="3ru0k4yayqor5">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1016" data-mp="3rvtq0bdr54y3">
          Trade References
        </h3>
        <div className="space-y-3" data-id="element-1017" data-mp="q209d3vzubt">
          {tradeReferences.map(ref => <div key={ref.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1018" data-mp="4nhoj601ve0y">
              {/* Collapsed Header */}
              <button onClick={() => setExpandedRef(expandedRef === ref.id ? null : ref.id)} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1019" data-mp="em5sj0v79sln">
                <div className="flex items-center gap-4" data-id="element-1020" data-mp="1jtuutecxea85">
                  <span className="font-semibold text-gray-900" data-id="element-1021" data-mp="1jvfpr535jv6j">
                    {ref.company}
                  </span>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1022" data-mp="1triqq7m9pnrw">
                    <div className="flex items-center gap-1" data-id="element-1023" data-mp="1ttvhnaa078h3">
                      <Calendar className="w-4 h-4" data-id="element-1024" data-mp="1xtvtcn5px5kg" />
                      {ref.statusText}
                    </div>
                    {ref.emailsSent && <>
                        <span className="text-gray-300" data-id="element-1025" data-mp="27q8nfm56dlfq">•</span>
                        <div className="flex items-center gap-1" data-id="element-1026" data-mp="2ci0j2b36uhcq">
                          <Mail className="w-4 h-4" data-id="element-1027" data-mp="2cisad9pr5sx7" />
                          {ref.emailsSent}
                        </div>
                      </>}
                  </div>
                </div>
                {expandedRef === ref.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1028" data-mp="2qh01h103y00g" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1029" data-mp="euy04bf98nyt" />}
              </button>

              {/* Expanded Content */}
              {expandedRef === ref.id && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1030" data-mp="5tgnx44yx6fe">
                  {/* Reference Information */}
                  <div className="mb-6" data-id="element-1031" data-mp="vouu6sl7e9m">
                    <div className="flex items-center gap-2 mb-4" data-id="element-1032" data-mp="wq7ugt5yatz">
                      <span className="font-semibold text-gray-900" data-id="element-1033" data-mp="xjmgql6pg74s">
                        Reference Information
                      </span>
                      <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1034" data-mp="tlosbkkrdp2g" />
                    </div>
                    <div className="grid grid-cols-2 gap-6" data-id="element-1035" data-mp="jtiys6euyzl5">
                      <div data-id="element-1036" data-mp="jt97mfi2umdv">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1037" data-mp="1h8wuhtmw4i09">
                          Company Name
                        </label>
                        <p className="text-gray-900" data-id="element-1038" data-mp="1ch5bc462dek5">{ref.company}</p>
                      </div>
                      <div data-id="element-1039" data-mp="1vfgnrh6lndrz">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1040" data-mp="1vf74sdjz26vs">
                          Contact Name
                        </label>
                        <p className="text-gray-900" data-id="element-1041" data-mp="1mmn5davuvy9w">{ref.contact.name}</p>
                      </div>
                      <div data-id="element-1042" data-mp="1qn73ohs617xm">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1043" data-mp="1qme01poi6yjp">
                          Contact Phone Number
                        </label>
                        <p className="text-gray-900" data-id="element-1044" data-mp="1hmr25duzgave">{ref.contact.phone}</p>
                      </div>
                      <div data-id="element-1045" data-mp="13nrb5zjzzjw2">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1046" data-mp="13okltbm2utjh">
                          Contact Work Email
                        </label>
                        <p className="text-gray-900" data-id="element-1047" data-mp="2y1aexr4mfypt">{ref.contact.email}</p>
                      </div>
                      {ref.contact.address && <div className="col-span-2" data-id="element-1048" data-mp="321ki6w114b0z">
                          <label className="text-sm text-gray-500 mb-1 block" data-id="element-1049" data-mp="qf8xh1pmzq2m">
                            Company Address
                          </label>
                          <p className="text-gray-900" data-id="element-1050" data-mp="mfrt6bly4yz1">{ref.contact.address}</p>
                        </div>}
                    </div>
                  </div>

                  {/* Status-specific content */}
                  {ref.status === 'pending' && <div data-id="element-1051" data-mp="1a26lhattomah">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1052" data-mp="1a5m4goqmafh6">
                        Awaiting Response
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1053" data-mp="1j4pmrqhymqum">
                        The reference request has been sent 1 times.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1054" data-mp="1e30dogeasn96">
                        <Send className="w-4 h-4" data-id="element-1055" data-mp="3fy0w4v5bf6yb" />
                        SEND REMINDER
                      </button>
                    </div>}

                  {ref.status === 'completed' && ref.details && <div data-id="element-1056" data-mp="3mekn7oy512uf">
                      <div className="flex items-center gap-2 mb-4" data-id="element-1057" data-mp="3rbb2wb615wfb">
                        <div className="font-semibold text-gray-900" data-id="element-1058" data-mp="3r9zzwdkessp9">
                          Reference Completed
                        </div>
                        <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1059" data-mp="2yo6sfqo64pw5" />
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1060" data-mp="33n9vx6oi2o20">
                        Response received on {ref.details.responseDate}
                      </p>
                      <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1061" data-mp="3dc1nhdpnf6ce">
                        <div className="flex justify-between" data-id="element-1062" data-mp="3dduuiu46bskx">
                          <span className="text-gray-600" data-id="element-1063" data-mp="2fvuo4ydyfejd">
                            Years as Customer
                          </span>
                          <span className="font-medium text-gray-900" data-id="element-1064" data-mp="2kte5i75y87fj">
                            {ref.details.yearsAsCustomer}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1065" data-mp="28b23xu2k9wzx">
                          <span className="text-gray-600" data-id="element-1066" data-mp="23cqp14xeswau">Credit Limit</span>
                          <span className="font-medium text-gray-900" data-id="element-1067" data-mp="1yfqkwzk4e3md">
                            {ref.details.creditLimit}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1068" data-mp="1pm3rhg3dxcgc">
                          <span className="text-gray-600" data-id="element-1069" data-mp="1pkkcdstgt7g5">Current Balance</span>
                          <span className="font-medium text-gray-900" data-id="element-1070" data-mp="1ko26uqqb952r">
                            {ref.details.currentBalance}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1071" data-mp="1ao32l60xc0vp">
                          <span className="text-gray-600" data-id="element-1072" data-mp="16n9cq73x8c06">Payment Habits</span>
                          <span className="font-medium text-gray-900" data-id="element-1073" data-mp="w2nr10jt9fi8">
                            {ref.details.paymentHabits}
                          </span>
                        </div>
                        <div className="flex justify-between col-span-2" data-id="element-1074" data-mp="10ze7hozj2d46">
                          <span className="text-gray-600" data-id="element-1075" data-mp="n3kb25fxxg7y">Recommended</span>
                          <span className="font-medium text-gray-900" data-id="element-1076" data-mp="s23thvvbs9vk">
                            {ref.details.recommended}
                          </span>
                        </div>
                      </div>
                    </div>}

                  {ref.status === 'not-sent' && <div data-id="element-1077" data-mp="16028n3hh0ac4">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1078" data-mp="15yr3p0cagwjf">
                        Ready to Send
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1079" data-mp="1yozcw2ouk6lv">
                        This trade reference request has not yet been sent to
                        the contact.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1080" data-mp="2cu9hfrnlf6jm">
                        <Send className="w-4 h-4" data-id="element-1081" data-mp="2mkulvvpy75ag" />
                        SEND REFERENCE
                      </button>
                    </div>}
                </div>}
            </div>)}
        </div>

        {/* Additional Trade References */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1082" data-mp="1ty0456kimk0o">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1083" data-mp="1pvwr4di777da">
            Additional Trade References
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1084" data-mp="23vo1m49ia5mj">
            No additional references requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1085" data-mp="1yxcp1lrtth0m">
            <Send className="w-4 h-4" data-id="element-1086" data-mp="3a9nblafz8gwm" />
            REQUEST ADDITIONAL TRADE REFERENCES
          </button>
        </div>
      </div>

      {/* Personal Guarantors */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1087" data-mp="1cml4c81eobyj">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1088" data-mp="1hlxryv03pn26">
          Personal Guarantors
        </h3>
        <div className="space-y-3" data-id="element-1089" data-mp="1mcnxc88j1pwv">
          {/* Michael Scott - Completed */}
          <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1090" data-mp="1meqtla09wfa1">
            {/* Collapsed Header */}
            <button onClick={() => setExpandedGuarantor(expandedGuarantor === 'michael' ? null : 'michael')} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1091" data-mp="1watvcer7qbwg">
              <div className="flex items-center gap-4" data-id="element-1092" data-mp="5yo2hbojgqgh">
                <span className="font-semibold text-gray-900" data-id="element-1093" data-mp="608tirbn9r9l">
                  Michael Scott
                </span>
                <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1094" data-mp="azbzqf3d23j5">
                  <div className="flex items-center gap-1" data-id="element-1095" data-mp="3favjd930b4v">
                    <Calendar className="w-4 h-4" data-id="element-1096" data-mp="3usdyli41bg7e" />
                    Completed on March 27, 2026
                  </div>
                  <span className="text-gray-300" data-id="element-1097" data-mp="3pu3yqu7d7rfg">•</span>
                  <div className="flex items-center gap-1" data-id="element-1098" data-mp="3kuzr4803a1r8">
                    <Mail className="w-4 h-4" data-id="element-1099" data-mp="3kseo3fo21frw" />1 email sent
                  </div>
                </div>
              </div>
              {expandedGuarantor === 'michael' ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1100" data-mp="heajeiorslzz" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1101" data-mp="cdmv44rxej9g" />}
            </button>

            {/* Expanded Content */}
            {expandedGuarantor === 'michael' && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1102" data-mp="2x55dvpbuyb6g">
                {/* Guarantor Information */}
                <div className="mb-6" data-id="element-1103" data-mp="2t2im1of6sq99">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1104" data-mp="2t5o8evwfle1a">
                    <User className="w-4 h-4 text-gray-600" data-id="element-1105" data-mp="1tgefpufqwbgz" />
                    <span className="font-semibold text-gray-900" data-id="element-1106" data-mp="1onlc59w0j96h">
                      Guarantor Information
                    </span>
                    <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1107" data-mp="1jpjrwlmup3tf" />
                  </div>
                  <div className="grid grid-cols-2 gap-6" data-id="element-1108" data-mp="1fp9pfiy9ovjb">
                    <div data-id="element-1109" data-mp="2cdxttch28ka9">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1110" data-mp="2cce9nasa9p37">
                        Full Name
                      </label>
                      <p className="text-gray-900" data-id="element-1111" data-mp="27crvmz4ms4tc">Michael Scott</p>
                    </div>
                    <div data-id="element-1112" data-mp="23eu96428vwtn">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1113" data-mp="1yefzyiowqgu1">
                        Title
                      </label>
                      <p className="text-gray-900" data-id="element-1114" data-mp="rym2prjp01cp">Regional Manager</p>
                    </div>
                    <div data-id="element-1115" data-mp="mxyflgyl44nr">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1116" data-mp="n0ubkzqvgj9k">
                        Email
                      </label>
                      <p className="text-gray-900" data-id="element-1117" data-mp="33kxycgwmi6pu">m.scott@dundermifflin.com</p>
                    </div>
                    <div data-id="element-1118" data-mp="37m9gk1d63po0">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1119" data-mp="37lzrcfzy5mjd">
                        Phone
                      </label>
                      <p className="text-gray-900" data-id="element-1120" data-mp="3cfm2u4udjkdl">(570) 555-0100</p>
                    </div>
                    <div data-id="element-1121" data-mp="3hep196fumscl">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1122" data-mp="3mbffdo83fdvd">
                        Address
                      </label>
                      <p className="text-gray-900" data-id="element-1123" data-mp="3rbtm92xykhrt">
                        1725 Slough Avenue, Scranton, PA 18503
                      </p>
                    </div>
                    <div data-id="element-1124" data-mp="1wx0vbh80sf67">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1125" data-mp="1wxspqopvs6uw">
                        SSN
                      </label>
                      <p className="text-gray-900" data-id="element-1126" data-mp="20ymc3dnoddlo">***-**-4927</p>
                    </div>
                  </div>
                </div>

                {/* Guarantee Completed */}
                <div data-id="element-1127" data-mp="2zbgryyeysici">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1128" data-mp="2zc9utoasynpd">
                    <div className="font-semibold text-gray-900" data-id="element-1129" data-mp="3dapz78l7024c">
                      Guarantee Completed
                    </div>
                    <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1130" data-mp="39afwc4sp5rtp" />
                  </div>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-1131" data-mp="3n69qfhotacmr">
                    Personal guarantee signed on March 27, 2026
                  </p>
                  <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1132" data-mp="t1hdp8xkd9i">
                    <div className="flex justify-between" data-id="element-1133" data-mp="3ryuiado5qfnn">
                      <span className="text-gray-600" data-id="element-1134" data-mp="3rzcmbwh29y64">Guarantee Amount</span>
                      <span className="font-medium text-gray-900" data-id="element-1135" data-mp="9u9fo7bg5e3l">$50,000</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1136" data-mp="4vg0magihf1b">
                      <span className="text-gray-600" data-id="element-1137" data-mp="og6hmssjjjh2">Date Signed</span>
                      <span className="font-medium text-gray-900" data-id="element-1138" data-mp="odtzofms9940">
                        March 27, 2026
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1139" data-mp="fe71s3t9ilfp">
                      <span className="text-gray-600" data-id="element-1140" data-mp="jgtyoj4siwjr">Guarantee Type</span>
                      <span className="font-medium text-gray-900" data-id="element-1141" data-mp="jiwu5iopphvv">
                        Unlimited
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1142" data-mp="ah752jiayv19">
                      <span className="text-gray-600" data-id="element-1143" data-mp="3rwncurbnfvxn">Expiration</span>
                      <span className="font-medium text-gray-900" data-id="element-1144" data-mp="3ryglgc5toq8a">None</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Additional Personal Guarantors */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1145" data-mp="3nvk04doweg0n">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1146" data-mp="3nx4p7nsg16r4">
            Additional Personal Guarantors
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1147" data-mp="3av9i5x15bltm">
            No additional guarantors requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1148" data-mp="364142novfca4">
            <Send className="w-4 h-4" data-id="element-1149" data-mp="320v1bq0yw38e" />
            REQUEST ADDITIONAL PERSONAL GUARANTORS
          </button>
        </div>
      </div>

      {/* Banking Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1150" data-mp="2s405xfzzqiyc">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1151" data-mp="2n4x19wnxaeqw">
          Banking Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1152" data-mp="2j54wzw5kaurc">
          <div data-id="element-1153" data-mp="lebp8ao63qhf">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1154" data-mp="letv7z0mtj2j">
              Bank Name
            </label>
            <p className="text-gray-900" data-id="element-1155" data-mp="hdrvzi6pt70k">Scranton National Bank</p>
          </div>
          <div data-id="element-1156" data-mp="1zav5y2vur0jt">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1157" data-mp="1z9aggroea7st">
              Contact
            </label>
            <p className="text-gray-900" data-id="element-1158" data-mp="247vfinrwulfo">Robert Lipton</p>
          </div>
          <div data-id="element-1159" data-mp="2917qvw7kwvqh">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1160" data-mp="291g6vwz00h5w">
              Type of Account
            </label>
            <p className="text-gray-900" data-id="element-1161" data-mp="2d3uka1jweops">Checking</p>
          </div>
          <div data-id="element-1162" data-mp="1gcsnk6xt81uz">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1163" data-mp="1gdbuytpu37ur">
              Account #
            </label>
            <p className="text-gray-900" data-id="element-1164" data-mp="1lcf0sgdn1i3s">481726350</p>
          </div>
          <div data-id="element-1165" data-mp="1pama4q5rvh4y">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1166" data-mp="1pea4frj1k7kq">
              Email
            </label>
            <p className="text-gray-900" data-id="element-1167" data-mp="30rck8kdbgt3u">r.lipton@scrantonnational.com</p>
          </div>
          <div data-id="element-1168" data-mp="30toxwlc1khb3">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1169" data-mp="35q5m1fj8qvo6">
              City
            </label>
            <p className="text-gray-900" data-id="element-1170" data-mp="15nmtgpdlbo9k">Scranton</p>
          </div>
          <div data-id="element-1171" data-mp="15q0q32nx58j8">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1172" data-mp="11muklx8mrldt">
              State
            </label>
            <p className="text-gray-900" data-id="element-1173" data-mp="1fmlubls46fm0">PA</p>
          </div>
          <div data-id="element-1174" data-mp="1fjzn5n94y24b">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1175" data-mp="1aniow08827di">
              Phone #
            </label>
            <p className="text-gray-900" data-id="element-1176" data-mp="mwwtp9jbghkx">570-555-0198</p>
          </div>
          <div data-id="element-1177" data-mp="hyll124rcd4a">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1178" data-mp="hz3mcd6a1hj2">
              Fax #
            </label>
            <p className="text-gray-900" data-id="element-1179" data-mp="wojbjoq5tewn">570-555-0199</p>
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1180" data-mp="rv6q1ngs1o84">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1181" data-mp="465cxmx01owi">Signature</h3>

        {/* Terms & Conditions */}
        <div className="mb-6" data-id="element-1182" data-mp="3vcos1e9vc10m">
          <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1183" data-mp="3vbnixfcexolj">
            Terms & Conditions
          </h4>
          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-4" data-id="element-1184" data-mp="2fm5sfc943gfk">
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1185" data-mp="2fo8u4tjmmy04">
              I understand that should my account become delinquent (terms of
              sale are based upon date of invoice) and that if the creditor
              elects to employ a third party to collect monies due, my company
              will be responsible for not only the original amount billed, but
              also all costs associated with the collection efforts including
              but not limited to reasonable attorney fees. Cash in Advance
              restrictions may be placed on any past due account. Customer will
              notify the creditor, in writing of any ownership changes or legal
              means of doing business by the company under which credit was
              established.
            </p>
          </div>
          <p className="text-sm font-semibold text-gray-900 mb-6" data-id="element-1186" data-mp="24v0a0qcq85u9">
            By signing the below you give Dunder Mifflin Paper Company Inc.,
            permission to check your bank and trade references.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1187" data-mp="1vvd5vwsm4lxi">
          <div data-id="element-1188" data-mp="1qvqrvl4yn1nn">
            <label className="text-sm font-medium text-gray-500 mb-2 block" data-id="element-1189" data-mp="1qwabr7e6804b">
              Signature
            </label>
            <div className="border-2 border-gray-300 rounded-lg p-4 bg-white h-32 flex items-center justify-center" data-id="element-1190" data-mp="2ohxx8x938y12">
              <svg viewBox="0 0 200 60" className="w-full h-full" style={{
              maxWidth: '200px'
            }} data-id="element-1191" data-mp="2jky23hds1foq">
                <path d="M 10 40 Q 20 20, 40 35 T 80 30 Q 100 25, 120 40 T 160 35 Q 170 30, 190 40" stroke="#1f2937" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-1192" data-mp="29ttksb0mpiqq" />
              </svg>
            </div>
          </div>
          <div data-id="element-1193" data-mp="39wjdfw90ydne">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1194" data-mp="3eszz8jsr4fxb">
              Printed Name
            </label>
            <p className="text-gray-900" data-id="element-1195" data-mp="3js3340wzwg3p">Dwight K. Schrute</p>
          </div>
          <div data-id="element-1196" data-mp="3or62p5u7hu4a">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1197" data-mp="3orphwesh24em">
              Title
            </label>
            <p className="text-gray-900" data-id="element-1198" data-mp="3ss9f1id1p80r">Assistant Regional Manager</p>
          </div>
          <div data-id="element-1199" data-mp="1lycfhsdzz7b">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1200" data-mp="1lf0chpf4517">
              Date
            </label>
            <p className="text-gray-900" data-id="element-1201" data-mp="6e85h6ostfdt">2026-03-27</p>
          </div>
        </div>
      </div>
    </div>;
}